import { Module } from 'vuex'
import { RootState } from '@/store/types'
import { Pager } from '@/store/pager.types'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'
import templates from './templates'
import { MailsState } from './types'

const Mails: Module<MailsState, RootState> = {
  state: (): MailsState => ({
    mails: [],
    pager: {
      current: 1,
      last: 1,
      totalLength: 0,
    },
  }),
  mutations,
  actions,
  getters,
  modules: {
    templates,
  },
}

export default Mails
